import React, { useState, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Picture } from 'formlabs-web-components/Media';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import TextPlugin from '../cms/TextPlugin';
import useIsMobile from '../../hooks/useIsMobile';
import captions from '../../../../public/video.vtt';
import countryContext from '../../context/country';

import './Card.module.css';

const VideoCard = ({
  children,
  bgColor,
  padding,
  body,
  videoPosition,
  border,
  videoImage,
  videoImageAlt,
  hover,
  video,
  classes
}) => {
  const handleMouseEnter = () => {
    setPlaying(true);
    if (videoDom.current) {
      videoDom.current.play();
    }
  };
  const handleMouseLeave = () => {
    setPlaying(false);
    if (videoDom.current) {
      videoDom.current.pause();
      setTimeout(() => {
        videoDom.current.currentTime = 0;
      }, 500);
    }
  };
  const [playing, setPlaying] = useState(false);
  const videoDom = useRef(null);
  const isMobile = useIsMobile();
  const country = useContext(countryContext);
  return (
    <div
      styleName={`card-wrapper video-card-wrapper ${bgColor} ${
        hover ? hover + '-hover' : ''
      }`}
      className={classes}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        styleName={classNames('video-card', videoPosition, {
          border: border
        })}
        style={{
          padding: padding
        }}
      >
        {!isMobile && (
          <div>
            <Picture largeImage={videoImage} alt={videoImageAlt} />

            <div styleName={classNames({ playing: playing })}>
              <video src={video} ref={videoDom} onEnded={handleMouseLeave}>
                <track
                  src={captions}
                  kind="captions"
                  srcLang={country.language}
                />
              </video>
            </div>
          </div>
        )}
        {isMobile && (
          <div>
            <Picture largeImage={videoImage} />
          </div>
        )}
        <div styleName="card-body">
          <div styleName="content">
            <TextPlugin body={body}>{children}</TextPlugin>
          </div>
        </div>
      </div>
    </div>
  );
};

VideoCard.propTypes = {
  children: PropTypes.any.isRequired,
  /** changes the background color of the card and text to match */
  bgColor: PropTypes.string,
  /** Main text of the card */
  body: PropTypes.node,
  /** Determines if image will be above or to the side of the body area */
  videoPosition: PropTypes.string,
  /** Determines whether to display grey border around the whole card or not */
  border: PropTypes.bool,
  /** Url for the large image in the card */
  image: PropTypes.string
};

export default DisplayComponent(VideoCard);
